import * as React from 'react'
import * as css from './CaseStudyResults.module.css'
import SanityBlock from 'components/common/SanityBlock'
import BlogCTA from 'components/common/ContactCTA'

const CaseStudyResults = ({ _rawContent }) => (
	<section className={`${css.root} grid gap-y-8 gap-x-16 max-w-screen-xl mx-auto py-20 px-4`}>
		<SanityBlock body={_rawContent} />

		<div>
			<BlogCTA className="md:max-w-[250px] mx-auto sticky-below-header" />
		</div>
	</section>
)

export default CaseStudyResults
